export default __webpack_public_path__ + "static/needlefilewithlittlebluewax-b62c8ca8b27d11e9e5d836410286d31c.png";